import React from 'react'

function Default() {
    return (
        <>
            <div className='w-full h-screen flex flex-col items-center justify-center bg-gray-200 space-y-2 p-10'>
                <h1 className='text-xl font-extralight'>Welcome</h1>
                <img src="https://fodderlink.com.au/wp-content/uploads/2021/07/fodder-logo.png" alt="" className='max-h-14'/>
                <h3 className='text-sm font-extralight text-center'>Supplier Portal</h3>
            </div>
        </>
    )
}

export default Default